import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";

const InvoiceView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const res = await api.get(`/pos/invoice/${id}`);
        setInvoice(res.data);
      } catch (err) {
        alert("Failed to load invoice");
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [id]);

  // ================= SAFETY =================
  if (loading) return <p>Loading invoice...</p>;
  if (!invoice) return <p>Invoice not found</p>;

  const items = invoice.items || []; // 🔒 defensive

  return (
    <div className="invoice-view page-container">
      {/* ================= HEADER ================= */}
      <div className="page-header">
        <h2>Invoice #{invoice.invoice_number}</h2>

        <div className="header-actions">
          <button onClick={() => navigate(-1)}>⬅ Back</button>
          <button
            className="primary-btn secondary"
            onClick={() =>
              navigate(`/print/${invoice.invoice_id}`)
            }
          >
            Re-Print
          </button>
        </div>
      </div>

      {/* ================= META ================= */}
      <div className="card invoice-meta">
        <div>
          <b>Date:</b>{" "}
          {new Date(invoice.invoice_date).toLocaleString()}
        </div>

        <div>
          <b>Branch:</b> {invoice.branch?.branch_name}
        </div>

        <div>
          <b>Payment Mode:</b> {invoice.payment_mode}
        </div>

        {(invoice.customer_name || invoice.customer_mobile) && (
          <>
            <div>
              <b>Customer:</b>{" "}
              {invoice.customer_name || "Customer"}
            </div>

            {invoice.customer_mobile && (
              <div>
                <b>Mobile:</b> {invoice.customer_mobile}
              </div>
            )}
          </>
        )}
      </div>

      {/* ================= ITEMS ================= */}
      <div className="card">
        <table className="invoice-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Item</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Taxable</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            {items.length === 0 && (
              <tr>
                <td colSpan="8" className="empty">
                  No items
                </td>
              </tr>
            )}

            {items.map((i, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{i.product_name}</td>
                <td align="right">{i.quantity}</td>
                <td align="right">₹{i.rate}</td>
                <td align="right">₹{i.taxable}</td>
                <td align="right">
                  ₹{i.cgst} ({i.gst_percent / 2}%)
                </td>
                <td align="right">
                  ₹{i.sgst} ({i.gst_percent / 2}%)
                </td>
                <td align="right">₹{i.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= TOTALS ================= */}
      <div className="card totals">
        <table width="100%">
          <tbody>
            <tr>
              <td align="right"><b>Taxable Value</b></td>
              <td align="right">₹{invoice.taxable_total}</td>
            </tr>
            <tr>
              <td align="right"><b>CGST</b></td>
              <td align="right">₹{invoice.cgst_total}</td>
            </tr>
            <tr>
              <td align="right"><b>SGST</b></td>
              <td align="right">₹{invoice.sgst_total}</td>
            </tr>
            <tr>
              <td align="right"><b>Grand Total</b></td>
              <td align="right">
                <b>₹{invoice.grand_total}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoiceView;
